import { xyz } from '@/Interfaces/common';
import { Vector3 } from 'three';

export const rackShift = 0.0034; // Добавляем слева и справа от ширины полки

export const minShelvesGap = 0.095;

export const backWallMinDistance = 0.3; // Минимальное расстояние до правой или левой стены при котором скрывается ползунок ширины
export const rackHoles = 0.03196; // Расстояние между отверстиями стойки
//0.0628, 0.095,
export const magnetDistance = 0.08; // Расстояние для примагничивания, когда перемещаем стойку по рельсу
export const rackCollisionDistance = 0.005; //Расстояние при котором прячем стойку при наложении
export const detachModuleDistance = 0.5; //Расстояние на котором происходит отстыковка модуля от группы
export const detachShelfDistance = 0.15;
export const magnetRackShift = 0; // Смещение при примагничивании
export const eventsNumLimit = 1; //Максимальное количество евентов за 20мс
export const eventLimitClearTime = 20;
export const unreachablePoint = new Vector3(-100, -100, -100);
export const windowModelUrl = '/assets/door_window.glb.xz';
export const windowModelName = 'window';
export const windowOffset = [ 0, 0, 0 ] as xyz;

export const doorModelUrl = '/assets/door.glb';
export const doorModelName = 'door';
export const doorOffset = [ 0, 1, 0.03 ] as xyz;
export const doorDepth = 0.03;

export const textFrameUrl = 'assets/FontAndFrame.glb';
export const textFrameName = 'size_plane';
export const textMeshName = 'Text';

export const lineArrowUrl = 'assets/LineArrow.glb';
export const lineModelName = 'line';
export const leftArrowName = 'Left';
export const rightArrowName = 'Right';

export const railShift = 0.025;//Смещение рельса слева
//invalidPlaceForShelf места где находится соединитель стоек
export const invalidPlaceForShelf = [ 69, 70, 71, 72, 73 ];
export const categoriesSections = {
    'construction': 1,
    'catalog': 2,
};

export const categoriesSectionsKeys = {
    1: 'construction',
    2: 'catalog',
};

export const urlForImage = 'https://praktik-home.dev2.nowmedia.ru/';

export const elementDnDTemplate = {
    visible: true,
    startX: 0,
    startY: 0,
    category: {},
    data: {},
};

export const appModes = {
    'empty': 0,
    'room': 1,
    'wardrobe': 2,
};

export const appModesKeys = {
    1: 'room',
    2: 'wardrobe',
};

export const typeToColorCategorySelected = {
    'wall': 'selectedWallCategory',
    'floor': 'selectedFloorCategory',
};

export const typeToColorSelected = {
    'wall': 'selectedWallColor',
    'floor': 'selectedFloorColor',
};
